import TileLayer from 'ol/layer/Tile'
import Map from 'ol/Map'
import ImageTile from 'ol/source/ImageTile'
import { environment } from '../../../environments/environment'

const AZURE_MAPS_BASE_URL =
  'https://atlas.microsoft.com/map/tile?zoom={z}&x={x}&y={y}&tileSize=256&language=EN&api-version=2.0'

type AzureTilesetId = 'microsoft.imagery' | 'microsoft.imagery.hybrid'

export class BackgroundLayer {
  private readonly satelliteLayer: TileLayer<ImageTile>
  private readonly hybridLayer: TileLayer<ImageTile>

  constructor(private readonly map: Map) {
    this.satelliteLayer = this.createAzureLayer('microsoft.imagery', true)
    this.hybridLayer = this.createAzureLayer('microsoft.imagery.hybrid', false)

    this.map.addLayer(this.satelliteLayer)
    this.map.addLayer(this.hybridLayer)
  }

  /**
   * Toggles the visibility between the satellite layer and the hybrid (satellite + labels) layer.
   * @param show True to show labels, false to hide them.
   */
  showMapLabels(show: boolean) {
    this.satelliteLayer.setVisible(!show)
    this.hybridLayer.setVisible(show)
  }

  /**
   * Creates an Azure Maps layer using the generic ImageTile source.
   */
  private createAzureLayer(tilesetId: AzureTilesetId, visible: boolean): TileLayer<ImageTile> {
    const azureUrl = `${AZURE_MAPS_BASE_URL}&subscription-key=${environment.azureMapsApiKey}&tilesetId=${tilesetId}`

    return new TileLayer({
      visible,
      preload: Infinity,
      zIndex: -1,
      source: new ImageTile({
        url: azureUrl,
        attributions: `© ${new Date().getFullYear()} TomTom, Microsoft`,
        crossOrigin: 'anonymous',
      }),
    })
  }
}
